import { render } from "./DetalharSaidaAnimal.vue?vue&type=template&id=772f19d6&scoped=true"
import script from "./DetalharSaidaAnimal.vue?vue&type=script&lang=js"
export * from "./DetalharSaidaAnimal.vue?vue&type=script&lang=js"

import "./DetalharSaidaAnimal.vue?vue&type=style&index=0&id=772f19d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-772f19d6"]])

export default __exports__